module.exports = __webpack_public_path__ + "img/ws.e03072bc.svg";